import { authRoleAccess } from 'auth/AuthRoleAccess';
import { lazy } from 'react';

const DocumentEdit = lazy(() => import('./DocumentEdit'));
const Documents = lazy(() => import('./Documents'));

const documentRoutes = [
  {
    path: '/documents',
    component: Documents,
    auth: authRoleAccess.document_view,
  },
  {
    path: '/documents/:id',
    component: DocumentEdit,
    auth: authRoleAccess.document_view,
  },
 
];

export default documentRoutes;
